{
  "fr": {
    "signature": {
      "actions": {
        "clearSignature": "Effacer la signature",
        "edit": "Modifier",
        "request": "Demander une signature",
        "save": "Enregistrer",
        "sign": "Inscrivez-vous"
      },
      "labels": {
        "add": "Ajouter",
        "add_customer_signatures": "Vous devez ajouter les signatures des clients avant d'enregistrer",
        "add_team_member_signatures": "Vous devez ajouter des signatures pour les membres de l'équipe avant d'enregistrer.",
        "all_customers_signed": "ous les acheteurs de maison demandés ont déjà signé. Les documents doivent toujours être signés par les représentants de {client_name} et la proposition sera approuvée une fois qu'ils les auront signés. Aucune autre action n'est requise de votre part.",
        "browserNotSupported": "Nous avons détecté que votre navigateur mobile ne prend pas en charge les signatures électroniques. Si vous rencontrez des problèmes, veuillez changer de navigateur ou d'appareil, ou télécharger un document signé à la place.",
        "customer_signatories": "Signataires client",
        "customers_left_to_sign": "1 client doit signer | {customers_left_to_sign} les clients doivent signer",
        "customers_required_to_sign": "1 autre acheteur doit signer les documents. | {customers_left_to_sign} plus d'acheteurs doivent signer les documents.",
        "customers_signed_names": "Clients déjà signés : {names}",
        "documents_to_sign": "Documents à signer",
        "draw_signature": "Apposez votre signature ci-dessous",
        "employee_signatories": "{client_name} signataires",
        "employees_signed_names": "Membres de l'équipe déjà signés : {names}",
        "empty_signature_warning": "La signature est vide. Vous devez d'abord apposer votre signature.",
        "marked": "Position de signature marquée",
        "next": "Suivant",
        "no_signature_indicators_warning": "Veuillez indiquer où le document doit être signé, en cliquant sur les pages.",
        "ok": "D'accord",
        "original": "Original",
        "page": "page",
        "place_signature_subtitle": "Cliquez sur les pages sur lesquelles vous souhaitez que le client appose sa signature",
        "place_signature_title": "Marquer où signer",
        "read_and_sign": "J'ai lu et souhaite signer",
        "read_documents": "Veuillez lire les documents suivants avant de les signer",
        "remove": "Effacez",
        "requesting_signage": "Demande de signalisation de",
        "sign": "Signer",
        "signatories_for_all_documents": "Le nombre de signataires s'applique à tous les documents. Le changer supprimera toutes les signatures et vous devrez les ajouter à nouveau.",
        "signatureNotPossible": "Les signatures numériques ne sont pas disponibles pour ce type de fichier",
        "signatureNotPossibleSize": "Les signatures numériques ne sont pas disponibles pour les fichiers de plus de 40 Mo",
        "signatures_pending_from_client": "Signatures en attente de l'équipe {client_name}",
        "signed": "Signé",
        "signed_progress": "Signé: {already_signed_count} sur {all_required_to_sign_count}",
        "specifyWhereToSign": "Marquer où signer",
        "team_member": "Membre de l'équipe",
        "team_member_signature_warning": "Vous pourrez demander la signalisation des membres de l'équipe après avoir demandé la signalisation des clients.",
        "thank_you_for_signing": "Merci d'avoir signé.",
        "toBeSigned": "À signer"
      }
    }
  }
}
